import WebGalleryAlbumFolderNullState from './WebGalleryAlbumFolderNullState';

export default WebGalleryAlbumFolderNullState;
